module.exports = __webpack_public_path__ + "img/preInscription_ilustration.664d68ec.png";